import React from 'react';
import { Button, Badge, Card } from './ui';
import { FileText, Zap, ShieldCheck, Lock, XCircle, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-4 pb-12 md:pt-6 md:pb-16 px-4 overflow-hidden pl-[16px] pr-[16px]" data-id="element-12" data-mp="38wm4tgeddyqp">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-teal-500/10 rounded-full blur-[120px] pointer-events-none" data-id="element-13" data-mp="3dunnw1bspy26"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-14" data-mp="33x99065ithbz">
        <div className="inline-flex items-center gap-2 mb-3" data-id="element-15" data-mp="33zlzx8t9b216">
          <span className="text-2xl" data-id="element-16" data-mp="2q75uk1cvurx3">🧩</span>
          <span className="text-teal-600 font-bold tracking-widest uppercase text-sm md:text-base" data-id="element-17" data-mp="2q4b7e22hiszz">
            PUNTO DIGITAL™
          </span>
        </div>

        <h1 className="font-black text-navy tracking-tight leading-[1.05] mb-3" data-id="element-18" data-mp="2g99fwzkqleu8">
          <span className="block text-[22px] sm:text-3xl md:text-4xl" data-id="element-19" data-mp="2l7b39wp740bi">
            TODO PARA MANEJAR
          </span>
          <span className="block text-teal-500 text-glow text-[32px] sm:text-5xl md:text-6xl my-0.5" data-id="element-20" data-mp="2mninpfv1dypf">
            LA CONDUCTA DE TU HIJO.
          </span>
          <span className="block text-[22px] sm:text-3xl md:text-4xl" data-id="element-21" data-mp="2vp9vcq950flx">
            EN UN SOLO KIT.
          </span>
        </h1>

        <div className="relative mt-3 mb-4 flex justify-center" data-id="element-22" data-mp="2qri31v4kyrh7">
          <div className="absolute inset-0 bg-teal-500/15 blur-[80px] rounded-full pointer-events-none" data-id="element-23" data-mp="230l21debpekq"></div>
          <img src="https://cdn.magicpatterns.com/uploads/vTAdqR1mo4KTmVfM83zDZp/mockup_landing_.png" alt="Kit de Conducta Infantil — los 3 tomos y los 5 bonos prácticos en formato digital" className="relative z-10 w-full max-w-lg h-auto drop-shadow-2xl pl-[45px] pr-[45px]" width={800} height={800} loading="eager" fetchPriority="high" decoding="async" data-id="element-24" data-mp="1yzssej1jh7nx" />
        </div>

        <p className="text-teal-500 font-black tracking-tight text-xl sm:text-2xl md:text-3xl" data-id="element-25" data-mp="1f9fjurkwua79">
          EL SISTEMA N°1 PARA PADRES
        </p>

        <p className="text-ink-muted max-w-2xl mx-auto text-[14px] sm:text-base leading-snug mt-2 mb-5" data-id="element-26" data-mp="3kbkr7vm1f5ws">
          Rabietas, límites, desobediencia, emociones y rutinas: herramientas
          prácticas para saber qué hacer en cada momento.
        </p>

        <div className="flex flex-nowrap justify-center gap-2 mb-6 overflow-x-auto" data-id="element-27" data-mp="2wenec0go0u80">
          <Badge className="whitespace-nowrap" data-id="element-28" data-mp="2wgrv3iznxnpp">
            <FileText className="w-4 h-4 mr-2 text-teal-600" data-id="element-29" data-mp="31cyqwiychitx" /> 100% Digital
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-30" data-mp="36cldhj02cbfe">
            <Zap className="w-4 h-4 mr-2 text-amber-500" data-id="element-31" data-mp="36exthqm9gbpt" /> Acceso inmediato
          </Badge>
          <Badge className="whitespace-nowrap" data-id="element-32" data-mp="3afriyofcpykt">
            <span className="mr-2" data-id="element-33" data-mp="ln5h88i2ruid">🧩</span> 3 Tomos + 5 Bonos
          </Badge>
        </div>

        <div className="flex flex-col items-center gap-5" data-id="element-34" data-mp="pnxst8ef6bht">
          <Button size="md" className="w-full md:w-auto group" onClick={() => document.getElementById('planes')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-35" data-mp="pqah03arti3b">
            <span className="mr-2 text-lg group-hover:scale-110 transition-transform" data-id="element-36" data-mp="21cwk2wdi0bbk">
              🧩
            </span>
            QUIERO MI KIT DE CONDUCTA INFANTIL AHORA
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-37" data-mp="1rfiddohdn0wg" />
          </Button>

          <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-ink-muted" data-id="element-38" data-mp="1mge653e0jd8r">
            <span className="flex items-center" data-id="element-39" data-mp="1iealpp9d8ybc">
              <ShieldCheck className="w-4 h-4 mr-1 text-emerald-600" data-id="element-40" data-mp="1ih6jndl7rmzs" /> Garantía
              7 días
            </span>
            <span className="flex items-center" data-id="element-41" data-mp="3ct3frjulph16">
              <Lock className="w-4 h-4 mr-1 text-ink-soft" data-id="element-42" data-mp="3csl7tpyktedf" /> Pago seguro
            </span>
            <span className="flex items-center" data-id="element-43" data-mp="37vbn2nm4tqvx">
              <Zap className="w-4 h-4 mr-1 text-teal-600" data-id="element-44" data-mp="24j362j3bc76f" /> Acceso inmediato
            </span>
          </div>
        </div>
      </div>
    </section>;
}
export function Testimonials() {
  const testimonios = [{
    src: 'https://cdn.magicpatterns.com/uploads/muiWTcXW9rGPViAvvkumsv/1.png',
    alt: 'Captura de WhatsApp: Juliana P. cuenta que el material le gustó mucho, es claro y práctico, y que ya está aplicando varias cosas con su hijo.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/kH6mGYR6KfjuzVPPc3Ro3v/2.png',
    alt: 'Captura de WhatsApp: Carolina R. cuenta que el material es completo y se entiende bien, y que ya está viendo cambios con su hijo.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/krT2v3u3w2Jqt8AFdbumVt/4_.png',
    alt: 'Captura de WhatsApp: Gonzalo M. cuenta que le ayudó a entender mejor a su hijo y a saber cómo reaccionar cuando no le hace caso.'
  }];
  return <section className="relative pt-9 pb-10 bg-navy overflow-hidden" data-id="element-45" data-mp="17ritm8eykddb">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[300px] bg-teal-500/10 blur-[110px] rounded-full pointer-events-none" aria-hidden="true" data-id="element-46" data-mp="o6iknwybprp8"></div>
      <div className="relative z-10 max-w-6xl mx-auto px-4" data-id="element-47" data-mp="y5racdm5ok5s">
        <div className="flex flex-wrap justify-center gap-6 md:gap-14 text-center mt-2 mb-8" data-id="element-48" data-mp="y355ilqngir9">
          <div data-id="element-49" data-mp="t87xni53wffy">
            <p className="text-4xl font-black text-white mb-1" data-id="element-50" data-mp="t8hm31ai6ejj">3</p>
            <p className="text-xs sm:text-sm text-teal-300 uppercase tracking-widest" data-id="element-51" data-mp="174bod1gru5no">
              Tomos prácticos
            </p>
          </div>
          <div data-id="element-52" data-mp="1gvg1rwqstige">
            <p className="text-4xl font-black text-white mb-1" data-id="element-53" data-mp="1gvzaqnyh0wia">5</p>
            <p className="text-xs sm:text-sm text-teal-300 uppercase tracking-widest" data-id="element-54" data-mp="1bwmn40zrzlen">
              Bonos incluidos
            </p>
          </div>
          <div data-id="element-55" data-mp="1px76ay9lrj8o">
            <p className="text-4xl font-black text-white mb-1" data-id="element-56" data-mp="1pwnnzgg1isu4">100%</p>
            <p className="text-xs sm:text-sm text-teal-300 uppercase tracking-widest" data-id="element-57" data-mp="1lvu0upaf9i2a">
              Digital
            </p>
          </div>
          <div data-id="element-58" data-mp="1svw81wpp82ah">
            <p className="text-4xl font-black text-white mb-1 flex items-center justify-center gap-1" data-id="element-59" data-mp="1xx3ensg3uvfk">
              <Zap className="w-8 h-8 fill-amber-400 text-amber-400" data-id="element-60" data-mp="22w6mfkngzfr8" />
            </p>
            <p className="text-xs sm:text-sm text-teal-300 uppercase tracking-widest" data-id="element-61" data-mp="22ubzk0sn1dki">
              Acceso inmediato
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-62" data-mp="2bnp0nq0uvlho">
          {testimonios.map((t, idx) => <Card key={idx} className="bg-white p-2 md:p-2 overflow-hidden" data-id="element-63" data-mp="2gma03n8aa152" data-mpi={idx}>
              <img src={t.src} alt={t.alt} className="w-full h-auto rounded-xl" loading="lazy" decoding="async" data-id="element-64" data-mp="2lmeixjwnz7yg" />
            </Card>)}
        </div>
      </div>
    </section>;
}
export function Problem() {
  return <section className="relative bg-[#0C2036] border-t border-white/10 py-11 px-4 overflow-hidden" data-id="element-65" data-mp="w8j7u449jnb6">
      <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-[720px] h-[320px] bg-teal-500/10 blur-[120px] rounded-full pointer-events-none" aria-hidden="true" data-id="element-66" data-mp="39it0i31izioe"></div>
      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-67" data-mp="30qhb8ki5e1a0">
        <h2 className="text-[28px] md:text-[42px] font-black text-center text-white leading-[1.1] tracking-tight mb-4" data-id="element-68" data-mp="2vquysda58p29">
          ¿Cuántas veces más vas a tener que{' '}
          <span className="text-teal-400" data-id="element-69" data-mp="3serhpot1zwgn">repetir lo mismo</span>?
        </h2>

        <p className="text-white/70 text-center text-[16px] leading-snug max-w-xl mx-auto mb-4" data-id="element-70" data-mp="3ofs5dj4zsxf6">
          Le pedís que guarde, se bañe o apague la tablet… y parece que nada
          funciona hasta que terminás perdiendo la paciencia.
        </p>

        <p className="text-lg font-bold text-center text-teal-300 mb-6" data-id="element-71" data-mp="280qwc98oyvcu">
          No te faltan ganas de hacerlo mejor. Te faltan herramientas para esos
          momentos.
        </p>

        <ul className="space-y-2.5 mb-8" data-id="element-72" data-mp="234a4p52a9yv0">
          {['Le pedís que guarde los juguetes y termina en discusión', 'Apagar la tablet provoca enojo o una rabieta', 'La hora del baño se convierte en negociación', 'Un simple “no” termina en llanto, enojo o frustración', 'La hora de dormir parece otra batalla', 'Terminás levantando la voz… y después aparece la culpa'].map((item, i) => <li key={i} className="flex items-center gap-4 rounded-2xl border border-coral-300 bg-white px-4 sm:px-5 py-3.5 shadow-[0_12px_30px_-22px_rgba(0,0,0,0.9)]" data-id="element-73" data-mp="pq2c86limz9j" data-mpi={i}>
              <XCircle className="w-7 h-7 text-coral-500 shrink-0" data-id="element-74" data-mp="fxeftcyg6xbc" />
              <span className="text-navy text-base md:text-lg font-medium" data-id="element-75" data-mp="kx96pgi83mwe">
                {item}
              </span>
            </li>)}
        </ul>

        <h3 className="text-2xl md:text-[32px] font-black text-center text-white leading-tight tracking-tight" data-id="element-76" data-mp="1delb5viodzoy">
          ¿Y si esta fuera la última semana en la que tenés que improvisar
          frente a estos momentos?
        </h3>
      </div>
    </section>;
}